/**
 * Created by Tiger on 21/02/2022.
 */
import React, {useEffect, useMemo, useState} from 'react';
import {Button, Dropdown, message, Modal, Pagination, Space, Table} from 'antd';
import Styles from '../config/css/ConfigManager.module.scss';
import DeviceHeader from './device-header';
import i18n from 'i18next';
import {connect} from 'react-redux';
import {useLocation} from 'react-router-dom'
import actions from '../../redux/action';
import tableMenu from '../../components/menu';
import NewDevice from './new-device';
import {http} from '../../common/request';
import {HttpURLS} from '../../common/http-url-define';
import {useTableSelection} from './use-table-selection';
import EditDevices from './edit-devices';
import {resultModal} from '../../components/result-modal';
import {changedConfigSuccessTip} from '../../common/util';
import {code} from 'react-markdown/lib/renderers';
import {MoreOutlined, TablePagination} from '../../components/lib';
import styled from '@emotion/styled';


function DeviceManager(props) {
  const location = useLocation();
  const [scrollY, setScrollY] = useState(document.body.clientHeight - 200);
  const {
    selectedMacs,
    setSelectedMacs,
    rowSelection,
    selectedCodes,
    addSelectedCode,
    clearSelected,
  } = useTableSelection();
  const [filter, setFilter] = useState({ hadPrivate: true });
  useEffect(() => {
    const h = document.getElementById('tableContainer').offsetHeight - 120;
    setScrollY(h);
  }, []);
  const deleteDevice = macList => {
    
    const replaceStr = macList.length === 1 ? macList?.[0] : ` ${ macList.join(',')  } `;
    Modal.confirm({
      icon: null,
      title: i18n.t('confirm_to_delete_device_title').replace('%$', replaceStr),
      content: i18n.t('confirm_to_delete_device_content'),
      okText: i18n.t('menu_delete'),
      cancelText: i18n.t('cancel'),
      onOk: () => {
        http('delete', HttpURLS.DEVICE_URL, { macList }).then(res => {
          if (res?.data?.code === 200) {
            props.onRefreshDeviceList(props.language, filter);
            clearSelected();
            message.success(i18n.t('delete_success'));
          } else {
            message.success(i18n.t('delete_failed') + `[${ code }]`);
          }
        }).catch(err => {
          message.success(i18n.t('delete_failed') + JSON.stringify(err));
        });
      },
    });
  };
  const listTableColumns = useMemo(() => ([{
    title: 'MAC/SN', dataIndex: 'mac', key: 'mac',
  }, { title: i18n.t('device_type'), dataIndex: 'name', key: 'name' }, {
    title: i18n.t('config'), dataIndex: 'configName', key: 'configName',
  }, { title: i18n.t('config_sent_time'), dataIndex: 'sendAt', key: 'sendAt' },
    {
      title: i18n.t('create_time'),
      dataIndex: 'createAt',
      key: 'createAt',
    }, {
      title: i18n.t('operations'),
      render: (record) =>
        <Dropdown arrow={ true } placement={ 'bottom' } trigger={ 'hover' }
                  overlay={ tableMenu.bind(this, {
                    onEdit: () => {
                      setSelectedMacs([record.mac]);
                      addSelectedCode(record.originalData.product.code);
                      setEditDeviceDialogVisible(true);
                    }, onDelete: () => {
                      deleteDevice([record.mac]);
                      console.log('delete onclick', record);
                    },
                  }) }>
          <div style={ { width: 50 } }>
            <MoreOutlined/>
          </div>
        </Dropdown>,
      key: 'operate',
    }]), [props.language]);
  const [newDeviceDialogVisible, setNewDeviceDialogVisible] = useState(false);
  const [editDeviceDialogVisible, setEditDeviceDialogVisible] = useState(false);
  const listRefresh = params => props.onRefreshDeviceList(props.language, { ...filter, ...params });
  const footer = () => {
    return <>
      {
        props.tableDataSource.length > 0 &&
        <FooterContainer>
          <Space direction={ 'horizontal' } style={ { marginTop: 5, marginBottom: 5 } }>
            <Button type={ 'primary' } disabled={ selectedMacs.length === 0 }
                    size={ 'middle' } onClick={ () => {
              setEditDeviceDialogVisible(true);
            } }>{ i18n.t('change_config') }</Button>
            <Button type={ 'primary' } disabled={ selectedMacs.length === 0 }
                    size={ 'middle' } onClick={ () => {
              deleteDevice(selectedMacs);
            } }>{ i18n.t('menu_delete') }</Button>
            <label
              style={ { fontSize: 16 } }>{ i18n.t('table_footer').replace('@$', `${ selectedMacs.length }`) }</label>
          </Space>
          <TablePagination
            total={ props.total }
            current={ props.currentPage }
            pageSize={ props.pageSize }
            refresh={ listRefresh }
          />
        </FooterContainer>
      }
    </>;
  };
  return <div className={ Styles.container }>
    <DeviceHeader 
      privateConfigId={ location?.state?.privateConfigId || null }
      setSelectedRows={ setSelectedMacs } 
      updateDeviceFilter={ filter => setFilter(filter) }
      addDevice={ () => {
        setNewDeviceDialogVisible(true);
      } }/>
    <div id={ 'tableContainer' } className={ Styles.tableContainer }>
      <Table rowKey={ ({ mac }) => mac } columns={ listTableColumns }
             rowSelection={ rowSelection }
             dataSource={ props?.tableDataSource }
             size={ 'small' }
             loading={ props.tableLoading }
             footer={ footer }
             pagination={ false }
             scroll={ { y: scrollY } }
      />
    </div>
    { newDeviceDialogVisible &&
    <NewDevice visible={ newDeviceDialogVisible }
               onCancel={ () => {
                 setNewDeviceDialogVisible(false);
               } }
               onOk={ ({ code }) => {
                 setNewDeviceDialogVisible(false);
                 let title, subTitle = '', status;
                 if (code === 200) {
                   status = 'success';
                   title = i18n.t('add_success_title');
                   subTitle = i18n.t('add_success_sub_title');
                 } else {
                   status = 'error';
                   title = i18n.t('add_success_fail');
                 }
                 resultModal({
                   title,
                   subTitle,
                   status,
                  //  extra: <Button type={ 'primary' }
                  //                 onClick={ () => Modal.destroyAll() }>{ i18n.t('consent') }</Button>,
                 });
               } }
               selectedRows={ selectedMacs }

    /> }
    { editDeviceDialogVisible && <EditDevices
      visible={ editDeviceDialogVisible }
      selectedRows={ selectedMacs }
      onCancel={ () => setEditDeviceDialogVisible(false) }
      onOk={ ({ code, configName }) => {
        setEditDeviceDialogVisible(false);
        let title, subTitle = '', status;
        if (code === 200) {
          status = 'success';
          title = i18n.t('edit_success_title');
          subTitle = changedConfigSuccessTip(selectedCodes[0]).replace('%0', `${ selectedMacs.length }`).replace('%1', configName);
          clearSelected();
        } else {
          status = 'error';
          title = i18n.t('edit_success_fail');
        }
        resultModal({
          title,
          subTitle,
          status,
          // extra: <Button type={ 'primary' } onClick={ () => Modal.destroyAll() }>{ i18n.t('consent') }</Button>,
        });
      } }
    /> }
  </div>;
}

const FooterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const mapState2Props = state => {
  return {
    language: state.language.language,
    tableDataSource: state.device.deviceList,
    tableLoading: state.device.tableLoading,
    total: state.device.total,
    currentPage: state.device.currentPage,
    pageSize: state.device.pageSize,
  };
};
const mapDispatch2Props = dispatch => {
  return {
    onRefreshDeviceList: (language, filter) => dispatch(actions.onDeviceList(language, filter)),
  };
};


export default connect(mapState2Props, mapDispatch2Props)(DeviceManager);
